'use client'

import { useContext } from 'react'
import { GlobalContext } from 'src/components/layout/GlobalContext'
import { DEFAULT_JOURNAL_DOMAIN_ROUTES } from 'src/_helpers/journalDomainRoutes'

export default function useJournalDomainRoutes() {
  const { journalDomainRoutes } = useContext(GlobalContext)

  return journalDomainRoutes || DEFAULT_JOURNAL_DOMAIN_ROUTES
}
